<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card
          border-variant="info"
          header-bg-variant="primary"
          header-text-variant="white"
          class="full-width"
        >
          <div slot="header">
            <strong>Create Taxcode</strong>
            <eb-button
              classic="mr-1 btn-primary"
              style="color: white; font-weight: bold; float: right"
              text="Back"
              @click="(e) => $emit('created', e)"
            ></eb-button>
          </div>
          <b-row>
            <b-col md="5">
              <c-input
                inputType="text"
                lableText="Tenant Country"
                v-model="inputObject.country"
              />
            </b-col>
            <b-col md="5">
              <c-input
                inputType="text"
                lableText="Tax Code"
                v-model="inputObject.taxCode"
              />
            </b-col>
          </b-row>
          <b-row>
            <b-col md="5">
              <label for="start-date">Start Date:</label>
              <b-input
                id="start-date"
                type="date"
                v-model="inputObject.startDate"
              ></b-input>
            </b-col>
            <b-col md="5">
              <label for="end-date">End Date:</label>
              <b-input
                id="end-date"
                type="date"
                v-model="inputObject.endDate"
              ></b-input>
            </b-col>
          </b-row>

          <div
            v-for="(data, idx) in inputObject.details"
            :key="idx"
            class="mt-4"
          >
            <b-col
              v-for="(taxLine, lIdx) in inputObject.details[idx].taxLines"
              :key="lIdx"
            >
              <b-row>
                <b-col md="10">
                  <b-row>
                    <b-col md="6">
                      <label for="start-date">Tax Line Name</label>
                      <b-input
                        id="start-date"
                        type="text"
                        v-model="taxLine.taxLineName"
                      ></b-input>
                    </b-col>
                    <b-col md="6">
                      <label for="start-date">Tax Rate</label>
                      <b-input
                        id="start-date"
                        type="text"
                        v-model="taxLine.taxRates[0].tax"
                      ></b-input>
                    </b-col>
                    <b-col md="6" class="mb-3">
                      <label for="start-date">Tax Line Type</label>
                      <eb-select
                        type="select"
                        :selected="taxLine.taxRates[0].rateType"
                        :options="['P']"
                        v-model="taxLine.taxRates[0].rateType"
                        label="text"
                        id="start-date"
                      ></eb-select>
                    </b-col>
                  </b-row>
                </b-col>

                <b-col md="2">
                  <div>
                    <b-button
                      class="d-block mb-1"
                      variant="primary"
                      size="sm"
                      @click="removeTaxLime(idx, lIdx)"
                      v-if="inputObject.details[idx].taxLines.length > 1"
                    >
                      Remove
                      <i class="fa fa-minus-circle"></i>
                    </b-button>
                    <b-button
                      class="d-block mt-1"
                      variant="primary"
                      size="sm"
                      @click="addTaxLines(idx)"
                      v-if="
                        inputObject.details[idx].taxLines.length - 1 === lIdx
                      "
                    >
                      Add Item
                      <i class="fa fa-plus-circle"></i>
                    </b-button>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </div>
          <hr />
          <div class="text-center">
            <eb-button
              class="btn mr-4"
              classic="mr-1 btn-primary"
              text="Save"
              @click.prevent="handleSubmit"
            ></eb-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import { shuffleArray } from "@/shared/utils";
import ebSelect from "@/components/FormElements/Select.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import moment from "moment";
import ebButton from "@/components/FormElements/Button";
import faqdetails from "@/components/MasterSetup/FAQ/FAQDetails.vue";

export default {
  name: "createfaq",
  components: {
    ebButton,
    cInput,
    ebSelect,
    faqdetails,
  },

  data: () => {
    return {
      show: true,
      mediatype: "",
      photo: "",
      scope: "",
      mediaOptions: ["VIDEO", "IMAGE", "DOCUMENT"],
      categoryOptions: ["Order", "Payment"],
      scopeOptions: ["PARTNER", "CUSTOMER"],
      category: "",
      topic: "",
      description: "",
      inputObject: {
        taxCode: "",
        country: "",
        startDate: "",
        endDate: "",
        details: [
          {
            shipFrom: "nil",
            shipTo: "nil",
            billTo: "nil",
            taxLines: [
              {
                taxLineName: "",
                taxRates: [
                  {
                    rangeStart: 0,
                    rangeEnd: 0,
                    rateType: "",
                    tax: 0,
                  },
                ],
              },
            ],
            btnText: "Add Line",
            isRemovable: false,
            id: 1,
          },
        ],
      },
    };
  },
  computed: {
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    onSelect() {
      if (this.mediatype == "image") {
        console.log(this.mediatype);
        show = "false";
      }
    },
    onClickTaxline(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable) {
        this.inputObject.details.map((obj) => {
          console.log("input object", obj);
          if (obj.btnText === "Add Line") {
            obj.btnText = "Remove";
            obj.isRemovable = true;
            obj.id = idx + 1;
          }
        });
        this.inputObject.details.push({
          shipFrom: "nil",
          shipTo: "nil",
          billTo: "nil",
          taxLines: [
            {
              taxLineName: "",
              taxRates: [
                {
                  rangeStart: 0,
                  rangeEnd: 0,
                  rateType: "",
                  tax: 0,
                },
              ],
            },
          ],
          btnText: "Add Line",
          isRemovable: false,
          id: this.inputObject.details.length + 1,
        });
        this.inputObject.details.sort((a, b) =>
          a.btnText > b.btnText ? -1 : b.btnText > a.btnText ? 1 : 0
        );
      } else this.inputObject.details.splice(idx, 1);
    },
    addTaxLines(index) {
      this.inputObject.details[index].taxLines.push({
        taxLineName: "",
        taxRates: [
          {
            rangeStart: 0,
            rangeEnd: 0,
            rateType: "",
            tax: 0,
          },
        ],
      });
    },
    removeTaxLime(detailIndex, lineIndex) {
      this.inputObject.details[detailIndex].taxLines.splice(lineIndex, 1);
    },
    changePhoto(e) {
      const reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = () => {
        this.photo = reader.result;
        this.$emit("readIMG", this.img);
      };
      reader.onerror = (err) => {
        console.error("reader : ", err);
      };
    },
    handleSubmit() {
      let dataObj;
      if (
        JSON.parse(sessionStorage.getItem("userLogin"))["role"] === "Tenant"
      ) {
        dataObj = {
          ...this.inputObject,
          startDate: moment(this.inputObject.startDate).toDate().getTime(),
          endDate: moment(this.inputObject.endDate).toDate().getTime(),
        };
      }
      dataObj.details.map((obj) => {
        delete obj.id;
        delete obj.isRemovable;
        delete obj.btnText;
      });
      this.$store.dispatch("taxcode/createTaxcode", dataObj).then(() => {
        this.$swal({
          title: "Success",
          text: "Taxcode added successfully!!",
          type: "success",
        });
        this.$emit("created", {});
        this.$store.dispatch(
          "taxcode/fetchTaxcodeListforTenant",
          this.$store.getters["auth/getUserID"]
        );
      });
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
</style>
